var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShoppingCartThin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.375 2C1.375 1.65482 1.65482 1.375 2 1.375H4.00006C4.27489 1.375 4.51747 1.55453 4.59778 1.81736L5.46261 4.64773H14C14.1853 4.64773 14.361 4.72992 14.4797 4.87214C14.5985 5.01435 14.648 5.20191 14.615 5.38421L13.5767 11.1115C13.5228 11.4088 13.2639 11.625 12.9617 11.625H6.03854C5.73637 11.625 5.47748 11.4088 5.42356 11.1115L4.39162 5.42031L3.53751 2.625H2C1.65482 2.625 1.375 2.34518 1.375 2ZM5.74857 5.89773L6.5604 10.375H12.4399L13.2515 5.89773H5.74857Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22 14.11C8.22 14.723 7.72304 15.22 7.11 15.22C6.49696 15.22 6 14.723 6 14.11C6 13.497 6.49696 13 7.11 13C7.72304 13 8.22 13.497 8.22 14.11Z",
    fill: "#414141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9407 14.11C12.9407 14.723 12.4437 15.22 11.8307 15.22C11.2177 15.22 10.7207 14.723 10.7207 14.11C10.7207 13.497 11.2177 13 11.8307 13C12.4437 13 12.9407 13.497 12.9407 14.11Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShoppingCartThin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ShoppingCartThin.594c6df196836b68053695a4e42fc6f7.svg";